export const MEMBERS_QUERY_KEYS = {
  membersWithLeastPhotoCards: ['membersWithLeastPhotoCards']
};
